import { derived } from "svelte/store";
import { faq as FAQEN } from '../constants/FAQ.en';
import { faq as FAQES } from '../constants/FAQ.es';
import { faq as FAQFR } from '../constants/FAQ.fr';
import { type Language, languageStore } from '../stores/language';
import { faq as IntlFAQEN } from '../constants/IntlFAQ.en';
import { faq as IntlFAQES } from '../constants/IntlFAQ.es';
import { isPrimaryCampaign } from "../constants/countries";

// TODO: will need international FAQ as well, later... 

// Setting it to typeof EN will make sure that the copy object has the same structure as the EN object.
// Typescript will complain otherwise. That's why we want to keep these files using .ts
export const FAQMap: Record<Language, () => ReturnType<typeof FAQEN>> = { en: FAQEN, fr: FAQFR, es: FAQES };
export const IntlFAQMap: Record<Language, () => ReturnType<typeof IntlFAQEN>> = { en: IntlFAQEN, fr: IntlFAQES, es: IntlFAQES };

// Setting a default, just in case it so happens that the language is something not supported for some reason.
export const faq = derived([languageStore], ([$language]) => {
  const language = $language || 'en';
  return isPrimaryCampaign ? FAQMap[language]() : IntlFAQMap[language]();
});
